import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import {
  Typography,
  MenuItem,
  Select,
  TextField,
  InputAdornment,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {
  createOrderPhoneNumber,
  setPhone,
  updatePhoneEditing,
} from '../../../redux/legacy/reducers/ducks/legacy/OrderDuck';
import { normalizeInput } from '../../../util/Helpers';

function OrderPhoneCard({ onAdjustedValue, onCheckoutUpdating }) {
  const dispatch = useDispatch();
  const [state, setState] = useState({ phone: '' });

  const {
    phones,
    selectedPhone,
    phoneNumber,
    isPhoneEditing,
    orderPhoneNumber,
  } = useSelector(({ profile, order }) => ({
    phones: profile.phones,
    selectedPhone: order.phone,
    phoneNumber: order?.phone,
    isPhoneEditing: order?.isPhoneEditing,
    orderPhoneNumber: order.orderPhoneNumber,
  }));

  const togglePhoneEditing = () => {
    dispatch(updatePhoneEditing(true));
  };

  useEffect(() => {
    if (!selectedPhone && phones) {
      const phone = phones.find((i) => i.primary);
      if (phone) {
        dispatch(setPhone(phone.number));
      }
    }
  }, [selectedPhone, phones, dispatch]);

  const handleSortClick = (_, value) => {
    const phone = phones.find((i) => i.number === value.props.value);

    if (phone) {
      dispatch(setPhone(phone.number));
      // dispatch(checkoutAdjust());
      if (onAdjustedValue) {
        onAdjustedValue('phone', phone.id);
      }
    }
  };

  const handleChange = ({ target: { value } }) => {
    setState((prevState) => ({
      phone: normalizeInput(value, prevState.phone),
    }));
  };

  useEffect(() => {
    dispatch(createOrderPhoneNumber(state.phone));
  }, [dispatch, state]);

  return (
    <>
      <Select
        value={phoneNumber}
        iconcomponent={KeyboardArrowDownIcon}
        onChange={handleSortClick}
        data-test-id="sortButton"
        disabled={onCheckoutUpdating}
      >
        {phones.map(({ id, number }) => (
          <MenuItem
            aria-label={number}
            key={id}
            value={number}
            data-test-id={`sortBy--${id}`}
          >
            <Typography variant="body1">{number}</Typography>
          </MenuItem>
        ))}
      </Select>
      <Typography
        onClick={() => togglePhoneEditing()}
        data-test-id="createNewPhoneButton"
        sx={{ cursor: 'pointer' }}
      >
        + Add new phone number
      </Typography>
      {isPhoneEditing && (
        <TextField
          placeholder="(xxx) xxx-xxxx"
          data-test-id="orderPhoneNumber"
          value={orderPhoneNumber}
          onChange={handleChange}
          InputProps={{
            inputMode: 'numeric',
            pattern: '[0-9]*',
            startAdornment: (
              <InputAdornment position="start">
                <LocalPhoneIcon />
              </InputAdornment>
            ),
          }}
          focused
          fullWidth
        />
      )}
    </>
  );
}

OrderPhoneCard.propTypes = {
  onAdjustedValue: PropTypes.func,
  onCheckoutUpdating: PropTypes.bool.isRequired,
};

OrderPhoneCard.defaultProps = {
  onAdjustedValue: null,
};

export default OrderPhoneCard;
